<template>
  <div class="pyramid-slide pyramid-mediterranean" ref="slide">
    <div class="piramide-aside--wrap">
      <img class="bg-mobile" src="../assets/aside-pyramid-mobile.png" />
      <div class="steps-indicator-wrap active" >
        <div class="dot" v-for="(food, index) in foodArray" :key="index" :class="currentStep === (index) ? 'selected' : ''"></div>
      </div>
      <div class="aside-slider--wrap" >
        <div class="aside-slide aside-slide-food" v-for="(food, index) in foodArray" 
        :key="index"
        :class="currentStep === (index) ? 'current' : currentStep > index ? 'viewed' : ''"
        >
          <p>
            {{
              $i18n.locale == 'it' ?
              food.nameITA
              :
              food.name
            }}
          </p>
          <img :src="food.foodSrc" />
          <p class="description">
            {{
              $i18n.locale == 'it' ?
              food.descriptionITA
              :
              food.description
            }}
          </p>
        </div>
      </div>
      <div class="piramide-arrow--wrap" @click="nextSlide">
        <img src="../assets/arrow-piramide.svg" />
      </div>
    </div>
    <div class="piramide-content--wrap">
      <PyramidSvgMediterranean />
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex';
import {preloadImages} from '../preload.js'
import {gsap, TimelineMax} from 'gsap'
import PyramidSvgMediterranean from './PyramidSvgMediterranean.vue'

export default {
  name: 'PyramidSliderMediterranean',
  props: ['isOverlay', 'startPyramidSliderMediterranean'],
  components:{
    PyramidSvgMediterranean
  },
  data(){
    return {
      currentStep: 0,
      canClick: true,
      foodArray: [
        {
          name: 'Whole grains',
          nameITA: 'Alimenti Integrali',
          id: 'MED-Whole_grains-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_WHOLE_GRAINS@300x.png`),
          description: 'These foods are rich in fiber and should be consumed twice a day. Wholegrain bread should be preferred to its refined counterpart.',
          descriptionITA: "Questi cibi sono ricchi di fibre e dovrebbero essere consumati due volte al giorno. Il pane integrale dovrebbe essere preferito alla sua controparte raffinata."
        },
        {
          name: 'Vegetables',
          nameITA: 'Verdura',
          id: 'MED-Vegetables-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_VEGETABLES@300x.png`),
          description: 'Vegetables should be part of every meal, respecting the seasons. Artichoke, tomato, chard, cucumber and eggplant are some examples. ',
          descriptionITA: " La verdura dovrebbe essere inclusa ad ogni pasto, rispettando le stagioni. Carciofi, pomodori, bietole, cetrioli e melanzane sono alcuni esempi."
        },
        {
          name: 'Fruits',
          nameITA: 'Frutta',
          id: 'MED-Fruits-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_FRUIT@300x.png`),
          description: 'Fruit is a healthy snack and provide vitamins and minerals, and have a low carbon footprint. ',
          descriptionITA: "La frutta può essere uno spuntino sano, è ricca di vitamine e minerali e ha una bassa impronta di carbonio."
        },
        {
          name: 'Low glycemic',
          nameITA: 'Alimenti a basso indice glicemico',
          id: 'MED-Low_glycemic-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_LOW_GLYCEMIC@300x.png`),
          description: 'Pasta, parboiled rice and barley have a low effect on blood glucose.',
          descriptionITA: "Pasta, riso parboiled e orzo hanno un basso impatto sulla glicemia."
        },
        {
          name: 'Vegetable oils',
          nameITA: 'Oli vegetali',
          id: 'MED-Vegetable_oil-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_VEGETABLE_OILS@300x.png`),
          description: 'These oils are liquid at room temperature and protect the heart. The Mediterranean produces more than 80% of the world’s olive oil. ',
          descriptionITA: "Questi oli sono liquidi a temperatura ambiente e proteggono il cuore. Il Mediterraneo produce oltre l'80% dell'olio d'oliva mondiale."
        },
        {
          name: 'Nuts',
          nameITA: 'Frutta secca e semi',
          id: 'MED-Nuts-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_NUTS@300x.png`),
          description: 'Nuts are rich in healthy unsaturated fats, but contain also proteins, fiber and minerals like calcium, iron, phosphorus and potassium.',
          descriptionITA: "La frutta secca a guscio è ricca di grassi insaturi, ma contiene anche proteine, fibre e minerali come calcio, ferro, fosforo e potassio."
        },
        {
          name: 'Fermented milk',
          nameITA: 'Latte fermentato',
          id: 'MED-Fermented_milk-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_FERMENTED_MILK@300x.png`),
          description: 'Yogurt and other fermented milk products have great health benefits, providing calcium and probiotics, healthy agents for the gut’s health.',
          descriptionITA: "Yogurt e altri prodotti a base di latte fermentato hanno grandi benefici per la salute, fornendo calcio e probiotici."
        },
        {
          name: 'Fish',
          nameITA: 'Pesce',
          id: 'MED-Fish-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_FISH@300x.png`),
          description: 'Fish and shellfish promote health if consumed three-four times a week. Sardines are typical of the Mediterranean Sea and are rich in omega-3. ',
          descriptionITA: "Il pesce favorisce la salute se consumato tre-quattro volte a settimana. Le sardine sono tipiche del Mediterraneo e sono ricche di omega-3."
        },
        {
          name: 'Legumes',
          nameITA: 'Legumi',
          id: 'MED-Legumes-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_LEGUMES@300x.png`),
          description: 'Legumes should be consumed three-four times a week. Chickpeas are ingredients of Italian farinata, Moroccan tajine and Middle-Eastern hummus.',
          descriptionITA: "I legumi sono consigliati tre-quattro volte a settimana. La farinata italiana, del tajine marocchino e dell'hummus mediorientale includono i ceci."
        },
        {
          name: 'Milk',
          nameITA: 'Latte',
          id: 'MED-Milk-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_MILK@300x.png`),
          description: 'You can choose milk daily or weekly, but fermented versions such as yogurt are best for health. ',
          descriptionITA: "Puoi scegliere il latte giornalmente o settimanalmente, ma le versioni fermentate come lo yogurt sono le migliori per la salute."
        },
        {
          name: 'Cheese',
          nameITA: 'Formaggio',
          id: 'MED-Cheese-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_CHEESE@300x.png`),
          description: 'Cheese can be eaten up to three times a week, and some examples include Parmesan and Emmenthal.',
          descriptionITA: "Il formaggio può essere consumato fino a tre volte a settimana, e alcuni esempi sono il parmigiano e l'emmenthal."
        },
        {
          name: 'Eggs',
          nameITA: 'Uova',
          id: 'MED-Eggs-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_EGGS@300x.png`),
          description: 'Eggs are an excellent source of protein. ',
          descriptionITA: "Le uova sono un'ottima fonte di proteine."
        },
        {
          name: 'Poultry',
          nameITA: 'Pollame',
          id: 'MED-Poultry-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_POULTRY@300x.png`),
          description: 'Poultry is a healthier and more sustainable alternative to red meat, and includes chicken and turkey.',
          descriptionITA: "Il pollame è un'alternativa più sana e sostenibile alla carne rossa e include pollo e tacchino."
        },
        {
          name: 'High Glycemic',
          nameITA: 'Alimenti ad alto indice glicemico',
          id: 'MED-High_glycemic-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_HIGH_GLYCEMIC@300x.png`),
          description: 'White bread, potatoes and refined rice have a high effect on blood glucose.',
          descriptionITA: " Il pane bianco, le patate e il riso raffinato hanno un elevato impatto sulla glicemia."
        },
        {
          name: 'Red Meat',
          nameITA: 'Carne rossa',
          id: 'MED-Red_meats-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_RED_MEATS@300x.png`),
          description: 'This group includes beef, lamb and pork. Choose it up to once a week for their impact on health and high carbon footprint.',
          descriptionITA: "Include manzo, agnello e maiale. Sceglila al massimo una volta a settimana per l’impatto sulla salute e l'elevata impronta di carbonio."
        },
        {
          name: 'Animal fats and Tropical Oils',
          nameITA: 'Grassi animali e oli tropicali',
          id: 'MED-Animal_fats-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_ANIMAL_FATS@300x.png`),
          description: 'Butter, hard margarine, palm and coconut oil are high in saturated fat. ',
          descriptionITA: "Il burro, la margarina solida, l’olio di palma e di cocco sono ricchi di grassi saturi."
        },
        {
          name: 'Cakes and pastries',
          nameITA: 'Dolci e prodotti da forno',
          id: 'MED-Cakes-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_CAKES_AND_PASTRIES@300x.png`),
          description: 'These foods are usually high in saturated fat but also in refined flour and sugar. ',
          descriptionITA: "Questi alimenti sono generalmente ricchi di grassi saturi ma anche di farina raffinata e zucchero."
        },
        {
          name: 'Processed Meats',
          nameITA: 'Carni processate',
          id: 'MED-Processed_meats-piramide',
          foodSrc: require(`../assets/MEDITERRANEAN/MED_PROCESSED_MEATS@300x.png`),
          description: 'Ham, bacon and sausages should be consumed occasionally. ',
          descriptionITA: "Alimenti come prosciutto, pancetta e salsicce dovrebbero essere consumati occasionalmente."
       }
      ]
    }
  },
  methods:{
    nextSlide(){
      if(!this.canClick) return;

      this.canClick = false;
      let TL = gsap.timeline();
      this.currentStep = this.currentStep + 1;
      let livello1 = this.$refs.slide.querySelectorAll('.livello-1')
      let livello2 = this.$refs.slide.querySelectorAll('.livello-2')
      

      if(this.currentStep < 18){
        let foodIndex = this.foodArray[this.currentStep].id;
        TL
        .to(`#${foodIndex}-1`, {opacity: 1,duration: .75})
        .to(`#${foodIndex}-2`, {opacity: 1,duration: .75, onComplete: () => this.canClick = true}, '-=.5')

      }else if(this.currentStep === 18){
        let leftAside = window.innerWidth > 767 ? '-25%' : '0'
        let topAside = window.innerWidth <= 767 ? '-35%' : '0'
        TL
        .to('.piramide-arrow--wrap', {autoAlpha: 0,duration: .75})
        .to('.piramide-aside--wrap', {left: leftAside, top:topAside, flex: '0 0 0', maxWidth: '0', duration: .75}, '-=.5')
        .to('.piramide-content--wrap', {flex: '0 0 100%', maxWidth: '100%', duration: .75}, '-=.5')
        .to(livello1, {opacity:1,duration: .5, stagger: .05}, '-=.5')
        .to(livello2, {opacity:1,duration: .5, stagger: .05}, '-=.45')
        .to('.cta-end-pyramids', {autoAlpha:1,duration: .5})

      }
    },
    transition(val){
      
      if(val === false){
        gsap.to('.piramide-wrap', {duration: .75, left: '-100%', ease: 'Power2.easeInOut', 
          onComplete: () => {
            this.$store.dispatch('openOverlay', '')
            this.$store.dispatch('setMenuCtaVisibility',true);
            this.$store.dispatch('triggerReply')
          }
        })
      }
    },
    openBadgeOverlay(){
      this.$store.dispatch('openBadge', 'pyramid')
    },
    showResults(){
      gsap.set('.piramide-slider .final--result-wrap', {opacity: 1})
      gsap.to('.piramide-content--wrap', {duration: .75, left: '-100%', ease: 'Power2.easeInOut'})
      gsap.to('.cta-end-pyramids', {delay: 0.5, autoAlpha:0,duration: .5})
      gsap.to('.piramide-slider .final--result-wrap', 
        {
          duration: .75, x: '0%', autoAlpha: 1, ease: 'Power2.easeInOut',
          onComplete: () => {
            gsap.to('.piramide-slider .balloon',{duration: .5, delay: .5, autoAlpha: 1, ease: 'Power2.easeInOut'})
            gsap.to('.piramide-slider .avatar--res',{duration: .5, delay: .75, opacity:1, x: 0, ease: 'Power2.easeInOut'})
            gsap.to('.cta-badge-pyramid',{duration: .5, delay: 1, opacity:1, ease: 'Power2.easeInOut'})
          }
        
        })
    }
  },
  mounted(){

  },
  watch: {
    startPyramidSliderMediterranean(val){
      if(!val){
        let foodIcons = this.$refs.slide.querySelectorAll('.food')
      
        for(var i = 0; i < foodIcons.length; i++){
          foodIcons[i].style.opacity = 0
        }
      }else{
        this.currentStep = -1;
        this.nextSlide()  
      }
      
    }
  }
}
</script>

<style lang="scss">
  .pyramid-mediterranean{
    position: absolute;
    top: 0;
    left: 100%;
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: flex-start;
    @media screen and (max-width: 767px){
      flex-direction: column;
      overflow: visible;
    }
    .piramide-aside--wrap{
      position: relative;
      flex: 0 0 25%;
      max-width: 25%;
      align-self: stretch;
      background-color: #E2E7EC;
      background-size: cover;
      background-position: 50%;
      overflow: hidden;
      background-image: url('../assets/aside-pyramid-desk.svg');
      @media screen and (max-width: 767px){
        flex: 0 0 35%;
        max-width: 100%;
        overflow: visible;
        background-image: none;
        background-color: #fff;
        z-index: 2;
      }
      .bg-mobile{
        display: none;
        @media screen and (max-width: 767px){
          position: absolute;
          top: 0;
          width: 100%;
          left: 0;
          display: block;
        }
      }
      .steps-indicator-wrap{
        position: absolute;
        top: 50%;
        transform:translateY(-50%);
        left: -20px;
        display: flex;
        flex-direction: column;
        align-content: center;
        transition: left .5s ease-in-out;
        &.active{
          left: 10px;
        }
        .dot{
          width: 10px;
          height: 10px;
          border-radius: 50%;
          border: 1px solid #000;
          margin: 10px auto;
          &.selected{
            background-color: #000;
          }
        }
        @media screen and (max-width: 767px){
          display: none;
        }
      }
      .aside-slider--wrap{
        position: absolute;
        width: 100%;
        height: auto;
        align-self: flex-start;
        display: flex;
        flex-direction: row;
        top: 150px;
        padding: 20px 0;
        transform: translateX(0);
        .aside-slide{
          position: absolute;
          transform: translateY(50px);
          opacity: 0;
          flex: 0 0 100%;
          text-align: left;
          transition: all .5s ease-in-out;
          max-width: 100%;
          width: 100%;
          &.aside-slide-food{
            text-align: center;
            left: 50%;
            transform: translateX(-50%);
            img{
              margin: 0 auto;
              max-width: 50%;
              @media screen and (max-width: 767px) {
                max-width: 40%;
              }
            }
            &.current{
              transform: translateY(0) translateX(-50%);
            }
            &.viewed{
              transform: translateY(-50px) translateX(-50%);
            }
          }
          &.current{
            transform: translateY(0);
            opacity: 1;
            transition: all .5s ease-in-out .5s;
          }
          &.viewed{
            transform: translateY(-50px) ;
            opacity: 0;
          }
          p{
            padding: 0 30px 0 40px;
            font-size: 18px;
            margin: 0 auto;
            &:nth-child(1){
              font-size: 24px;
              margin-bottom: 30px;
            }
            &.description{
              font-size: 14px;
              @media screen and (max-width: 767px){
                font-size: 12px;
              }
            }
            @media screen and (max-width: 767px){
              font-size: 14px;
              padding: 0;
              width: 70%;
              max-width: 70%;
              &:nth-child(1){
                font-size: 18px;
                margin-bottom: 10px;
              }
            }
          }
        }
        @media screen and (max-width: 767px){
          top: 20px;
        }
      }
      .piramide-arrow--wrap{
        position: absolute;
        bottom: 50px;
        right: 20px;
        text-align: right;
        img{
          display: block;
          width: 40px;
          cursor: pointer;
        }
        @media screen and (max-width: 767px){
          bottom: 0;
          transform: translateY(100%);
        }
      }
    }
    .piramide-content--wrap{
      position: relative;
      flex: 0 0 75%;
      max-width: 75%;
      align-self: stretch;
      display: flex;
      align-items: center;
      background-color: #fff;
      svg{
        width: 80%;
        margin: 0 auto;
      }
      @media screen and (max-width: 767px){
        flex: 0 0 65%;
        max-width: 100%;
        svg{
          width: 90%;
        }
      }
    }
  }

</style>